import * as React from "react"
import request from "@/server/request"
import config from "@/server/config"
import alert from "@/pages/components/common/alert"
import "./index.scss"

interface initProps {
	history: any
}

class UserInfo extends React.Component<initProps, any> {
	constructor(props: any) {
		super(props)
		this.state = {
			phone: "",
			email: "",
			trader: "",
			isRealname: false,
			bind_qq: false,
			bind_wx: false,
		}
	}

	componentDidMount() {
		this.getData()
		this.getBindData()
	}

	render() {
		return (
			<div className="page-userInfo">
				<ul className="drawer-list">
					<li
						className="drawer-item"
						onClick={() =>
							this.props.history.push(
								`/replace_phone?phone=${this.state.phone}`
							)
						}
					>
						<span className="left-label">手机号码</span>
						<span className="right-label">{this.state.phone}</span>
						<i className="right-icon"></i>
					</li>
					<li
						className="drawer-item"
						onClick={() =>
							this.props.history.push(`/bind_email?email=${this.state.email}`)
						}
					>
						<span className="left-label">电子邮箱</span>
						<span className="right-label">{this.state.email}</span>
						<i className="right-icon"></i>
					</li>
					<li
						className="drawer-item"
						onClick={() =>
							this.props.history.push(
								`/bind_trader?trader=${
									this.state.trader ? encodeURIComponent(this.state.trader) : ""
								}`
							)
						}
					>
						<span className="left-label">我的交易员</span>
						<span className="right-label">{this.state.trader}</span>
						<i className="right-icon"></i>
					</li>
					<li
						className="drawer-item"
						onClick={() => this.props.history.push("/auth/realname")}
					>
						<span className="left-label">个人实名认证</span>
						<span className="right-label">{this.state.isRealname}</span>
						<i className="right-icon"></i>
					</li>
					<li
						className="drawer-item"
						onClick={() => (!this.state.bind_wx ? this.isWx() : "")}
					>
						<span className="left-label">微信绑定</span>
						<span className="right-label">
							{this.state.bind_wx ? "已绑定" : "未绑定"}
						</span>
						<i className="right-icon"></i>
					</li>
					<li
						className="drawer-item"
						onClick={() => (!this.state.bind_qq ? this.toAuth("QQ") : "")}
					>
						<span className="left-label">QQ绑定</span>
						<span className="right-label">
							{this.state.bind_qq ? "已绑定" : "未绑定"}
						</span>
						<i className="right-icon"></i>
					</li>
				</ul>
			</div>
		)
	}

	private isWx() {
		const ua = navigator.userAgent.toLowerCase()
		if ((ua as any).match(/MicroMessenger/i) == "micromessenger") {
			this.toWXAuth()
			return true
		}
		alert.open({
			promptText: "请在微信环境打开！",
		})

		return false
	}
	private async toWXAuth() {
		const returnUrl = encodeURIComponent(
			encodeURIComponent(window.location.origin + "/mobile/uc/build")
		)
		window.location.href = `${
			config.WAPAPI
		}login/wechat/auth?scope=2&userType=3&returnUrl=${returnUrl}&businessUrl=${this.getOuthBackUrl()}`
	}

	private getOuthBackUrl() {
		const returnUrl = GetQueryString("returnUrl")

		function GetQueryString(name: any) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
			var r = window.location.search.substr(1).match(reg)
			if (r != null) return unescape(r[2])
			return null
		}

		if (returnUrl) {
			return returnUrl
		} else {
			return encodeURIComponent(
				encodeURIComponent(window.location.origin + "/mobile/uc/build")
			)
		}
	}

	private async toAuth(type: any) {
		const returnUrl = encodeURIComponent(
			encodeURIComponent(window.location.origin + "/mobile/uc/build")
		)
		window.location.href = `${
			config.WAPAPI
		}oauth?type=${type}&returnUrl=${returnUrl}&businessUrl=${this.getOuthBackUrl()}`
	}

	private async getData() {
		const r = await request({
			method: "post",
			// API
			url: `${config.CE}member/info`,
		})

		if (r.code !== 1) {
			alert.open({
				promptText: r.message,
			})
		} else {
			this.setState({
				phone: r.obj.mobile,
				isRealname: this.personAuthText(r.obj.personalAuthenticationStatus),
				email: r.obj.email,
				trader: r.obj.trader,
			})
		}
	}

	// 用户绑定信息
	private async getBindData() {
		const r = await request({
			method: "post",
			url: `${config.WAPAPI}safety/account/get`,
			data: {
				queryType: 2,
			},
		})

		if (r.code !== 1) {
			alert.open({
				promptText: r.message,
			})
		} else {
			const data = r.obj.authAccount ? r.obj.authAccount : ""

			if (!data) {
				return
			}

			this.setState({
				bind_qq: data.qq ? true : false,
				bind_wx: data.weChat ? true : false,
			})
		}
	}

	private personAuthText(data: string) {
		switch (data) {
			case "0":
				return "未认证"
				break
			case "1":
				return "已认证"
				break
			case "2":
				return "待重新认证"
				break
			case "3":
				return "待审核"
				break
			default:
				return ""
		}
	}
}

export default UserInfo
